import React, { useState, useEffect, useMemo } from "react";
import {
  Box,Typography, Button,Card, CardContent,
  Grid,Divider,Dialog, DialogTitle,  DialogContent,CircularProgress,useTheme, Tooltip 
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation } from "react-router-dom";
import { message } from "antd";
import ApiCallService from "../../Service/ApiCallService";
import Spinner from "../../components/common/Spinner";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import LaunchIcon from "@mui/icons-material/Launch";

const DUPLICATE_INTEREST_MESSAGE =
  "You have already expressed interest in this program for this chapter.";

const ProgramDetails = () => {
  const theme = useTheme();

  const location = useLocation();
  const initialProgram = location?.state?.program;
  const [openDialog, setOpenDialog] = useState(false);
  const [chapters, setChapters] = useState([]);
  const [chapterLoading, setChapterLoading] = useState(false);
  const [submittingChapterId, setSubmittingChapterId] = useState("");
  const [loading, setLoading] = useState(false);

  const [programDetails, setProgramDetails] = useState(null);
  const [existingInterests, setExistingInterests] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);


const PROGRAM_LINKS = {
  "Samajik Samvaad": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/BJS%20Manthan%20Document%20(3).pdf?csf=1&web=1&e=ei9FaF"
  },

  "Parents Training": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Marenting%20Document%20(2).pdf?csf=1&web=1&e=OfjAm9"
  },

  "Pre Marriage Counselling": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Pre%20Marriage%20Counselling%20Document%20(1).pdf?csf=1&web=1&e=BbiPEg"
  },

  "Parinay Path": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Parinay%20Path%20Document%20(3).pdf?csf=1&web=1&e=ejxlXW"
  },

  "Mingle Carnival": {
    website: "https://the-octopus.com/api/vivaah-verse",
    android: "https://play.google.com/store/apps/details?id=com.bjsindia.bjscommunity&pcampaignid=web_share",
    ios: "https://apps.apple.com/us/app/vivaah-verse/id1492028341",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Vivaah%20Verse%20Mobile%20App%20Concept%20Doc%20(2).pdf?csf=1&web=1&e=42FOqU"
  },

  "Biodata Bank": {
    website:
      "https://allprojects.ct.ws/pi/biodatabank/login",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Biodata%20Document%20(4).pdf?csf=1&web=1&e=bqVT2p"
  },

  "Mention Knot": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Mention%20Knot%20Document%20(4).pdf?csf=1&web=1&e=F4k1JO"
  },

  "Post Marriage Counselling": {
    website: "",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Post%20Marriage%20Counselling%20Document%20(1).pdf?csf=1&web=1&e=nIqALs"
  },

  "Humsafar Dobara": {
    website: "https://the-octopus.com/api/VVregistrationpage",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Humsafar%20Dobara%20Document%20(1).pdf?csf=1&web=1&e=B2qgIe"
  },

  "Jain Parivarik Adalat": {
    website: "https://the-octopus.com/api/adaalatForm",
    android: "",
    ios: "",
    programDoc:"",
    conceptDoc:"https://smfmutthafoundation-my.sharepoint.com/:b:/r/personal/ajoshi_bjsindia_org/Documents/Dastak%20Program%20-%20All%20Documents/10%20Program%20-%20Concept%20Document/Jain%20Parivarik%20Adalat%20Document%20(2).pdf?csf=1&web=1&e=jvXjhI"
  },
};

  // ---------------- FETCH PROGRAM ----------------
  async function fetchProgram() {
    if (!initialProgram?._id) {
      message.error("Program details not found.");
      return;
    }

    try {
      setLoading(true);
      const res = await ApiCallService.get(`/programs/${initialProgram._id}`);

      // IMPORTANT: API shape is { success, program, folders }
      const program = res?.program || res;

      if (!program) {
        message.error("Program not found.");
        return;
      }

      setProgramDetails(program);
    } catch (err) {
      console.error("Program fetch error:", err);
      message.error("Failed to fetch program details.");
    } finally {
      setLoading(false);
    }
  }

  const fetchInterests = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) return;

    try {
      const res = await ApiCallService.get("/program-interests");

      const all = res?.data || [];

      // filter only current user + current program
      const filtered = all.filter(
        (i) => i?.userId?._id === userId && i?.programName === programName,
      );

      setExistingInterests(filtered);
    } catch (err) {
      console.error("Interest fetch error:", err);
    }
  };

  useEffect(() => {
    fetchProgram();
    fetchInterests();
  }, []);

  const isInterestDisabled = (chapterId) => {
    return existingInterests.some((i) => i?.chapterId?._id === chapterId);
  };

  // ---------------- DERIVED PROGRAM ----------------
  const program = programDetails || initialProgram;

  const programName = program?.name || "Program Details";
  const programConfig = PROGRAM_LINKS[programName] || {};
  const description = program?.description || "No description available.";

  const programImage = useMemo(() => {
    return (
      program?.programFrontImage ||
      program?.programPicture ||
      program?.programBackImage ||
      ""
    );
  }, [program]);

  // ---------------- CHAPTERS ----------------
  const fetchChapters = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      message.error("User not found. Please login again.");
      return;
    }

    try {
      setChapterLoading(true);
      const data = await ApiCallService.get(`/chapter-members/user/${userId}`);

      setChapters(Array.isArray(data) ? data : data?.data || []);
    } catch (err) {
      console.error("Chapter fetch error:", err);
      message.error("Failed to fetch chapters.");
    } finally {
      setChapterLoading(false);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
    fetchChapters();
  };

  // ---------------- EXPRESS INTEREST ----------------
  const handleShowInterest = async (chapter) => {
    const userId = localStorage.getItem("userId");
    const chapterId = chapter?.chapterId;

    if (!userId || !chapterId || !programName) {
      message.error(
        "Unable to show interest. Missing user, chapter, or program details.",
      );
      return;
    }

    try {
      setSubmittingChapterId(chapterId);

      await ApiCallService.post("/program-interests", {
        userId,
        chapterId,
        programId: program._id,
        programName,
      });

      message.success("Interest submitted.");
      fetchInterests();
    } catch (err) {
      const status = err?.response?.status;
      const apiMessage = err?.response?.data?.message;

      if (status === 409) {
        message.error(apiMessage || DUPLICATE_INTEREST_MESSAGE);
      } else {
        message.error(apiMessage || "Request failed.");
      }
    } finally {
      setSubmittingChapterId("");
    }
  };

  // ---------------- UI ----------------
  return (
    <Box sx={{ p: 2, maxWidth: 1400, mx: "auto" }}>
      <Spinner loading={loading} />

      {/* HERO SECTION */}
      <Card sx={{ borderRadius: 3, mb: 3, overflow: "hidden" }}>
        <Grid container>
          <Grid item xs={12} md={7}>
            <CardContent sx={{ p: {xs:1, md:2}, display:"flex", flexDirection:"column", justifyContent:"space-between", height:"100%" }}>
              <Box>
              <Typography variant="h4" fontWeight={700} color="primary">
                {programName}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mt: 1, lineHeight: 1.6 }}
              >
                {description}
              </Typography>
              </Box>
              <Box
  sx={{
    // mt: 2,
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifySelf: "flex-end",
  }}
>
  {/* Website */}
  {programConfig.website && (
        <Tooltip title="Open Website" arrow>

    <Button
      variant="contained"
      endIcon={<LaunchIcon />}
      onClick={() => window.open(programConfig.website, "_blank")}
      sx={{
        borderRadius: 2,
        textTransform: "none",
      }}
    >
      Visit Website
    </Button>
    </Tooltip>  
  )}

 {/* Android */}
{programConfig.android && (
  <Tooltip title="Download from Google Play Store" arrow>
    <IconButton
      color="success"
      onClick={() => window.open(programConfig.android, "_blank")}
      sx={{
        border: "1px solid #ddd",
      }}
    >
      <AndroidIcon />
    </IconButton>
  </Tooltip>
)}

  {/* iOS */}
  {programConfig.ios && (
      <Tooltip title="Download from App Store" arrow>

    <IconButton
      onClick={() => window.open(programConfig.ios, "_blank")}
      sx={{
        border: "1px solid #ddd",
      }}
    >
      <AppleIcon />
    </IconButton>
    </Tooltip>  
  )}

  {/* Program Document */}
  {programConfig.programDoc && (
        <Tooltip title="Open Program Document" arrow>

    <Button
      variant="contained"
      // endIcon={<LaunchIcon />}
      onClick={() => window.open(programConfig.conceptDoc, "_blank")} // need to add modal here but confirm if we can add buttons like these.
      sx={{
        borderRadius: 2,
        textTransform: "none",
      }}
    >
      View Program Document
    </Button>
    </Tooltip>  
  )}

  {/* Concept Document */}
  {/* {!programConfig.conceptDoc && (
        <Tooltip title="Open concept document" arrow>

    <Button
      variant="contained"
      // endIcon={<LaunchIcon />}
      onClick={() => window.open(programConfig.conceptDoc, "_blank")}
      sx={{
        borderRadius: 2,
        textTransform: "none",
      }}
    >
      View Concept Document
    </Button>
    </Tooltip>  
  )} */}

</Box>
    
            </CardContent>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box sx={{ width: "100%", height: 250, bgcolor: "grey.100" }}>
              {programImage ? (
                <Box
                  component="img"
                  src={programImage}
                  alt={programName}
                  sx={{
                    width: "100%",
                    height: "100%",
                    // height: 260,
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    p: 3,
                    color: "text.secondary",
                  }}
                >
                  <Typography>No program image available</Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Card>

  

<Grid container spacing={3}>
  <Grid item xs={12}>
    <Card
      sx={{
        borderRadius: 4,
        p: 2,
        border: "1px solid #f1d4cb",
      }}
    >
      {/* HEADER */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <InfoOutlinedIcon sx={{ color: "#ef7f6a" }} />
        <Typography variant="h6" fontWeight={800}>
          Guidelines & Documents
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* GRID */}
      {programDetails?.howToImplement?.length ? (
        <Grid
          container
          spacing={1}
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(5, minmax(140px, 1fr))",
            justifyContent: "center",
          }}
        >
          {programDetails.howToImplement.map((item, index) => (
            <Grid item key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  background: "#fff",
                  border: "1px solid #f1d4cb",
                  transition: "transform 0.2s",
                  minWidth: 148,
                  height: 192,
                  mx: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 10px 26px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <Box
                  sx={{
                    height: 110,
                    bgcolor: "grey.100",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      height: 44,
                      width: 44,
                      borderRadius: 2,
                      bgcolor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PictureAsPdfIcon sx={{ fontSize: 24, color: "#f59e0b" }} />
                  </Box>
                </Box>

                <Box sx={{ p: 1, bgcolor: "#fff" }}>
                  <Typography
                    fontWeight={700}
                    sx={{
                      fontSize: 12,
                      lineHeight: 1.3,
                      textAlign: "center",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: 36,
                      mb: 0.75,
                    }}
                  >
                    {item.name}
                  </Typography>

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPreviewFile(item);
                    }}
                    sx={{
                      width: "100%",
                      px: 0,
                      py: 0.5,
                      borderRadius: 2,
                      fontSize: 11,
                      textTransform: "none",
                      borderColor: "#f1d4cb",
                    }}
                  >
                    View
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography color="text.secondary">
          No guidelines available.
        </Typography>
      )}
    </Card>
  </Grid>
</Grid>

<Dialog
  open={Boolean(previewFile)}
  onClose={() => setPreviewFile(null)}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      height: "92vh",
      borderRadius: 4,
      overflow: "hidden",
    },
  }}
>
  {/* HEADER */}
  <DialogTitle
    sx={{
      position: "relative",
      height: 52, 
      display: "flex",
      alignItems: "center",
      justifyContent: "center", 
      borderBottom: "1px solid #eee",
      px: 2,
    }}
  >
    {/* CENTER TITLE */}
    <Typography
      fontWeight={700}
      fontSize={14}
      sx={{
        maxWidth: "80%",
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {previewFile?.name}
    </Typography>

    <IconButton
      onClick={() => setPreviewFile(null)}
      sx={{
        position: "absolute",
        right: 10,
        top: 6,
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  {/* BODY */}
  <DialogContent
    sx={{
      p: 0,
      bgcolor: "#f9fafb",
      position: "relative",
    }}
  >
    {/* LOADER */}
    {pdfLoading && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fff",
          zIndex: 2,
        }}
      >
        <CircularProgress />
      </Box>
    )}

    {previewFile?.fileUrl && (
      <iframe
        src={`${previewFile.fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
        width="100%"
        height="100%"
        style={{ border: "none", minHeight: "85vh" }}
        onLoad={() => setPdfLoading(false)}
      />
    )}
  </DialogContent>
</Dialog>



      {/* DIALOG */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 3,
            position: "relative",
            borderBottom: "1px solid #F1F5F9",
          }}
        >
          <IconButton
            onClick={() => setOpenDialog(false)}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "#64748B",

              "&:hover": {
                background: "#F1F5F9",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: 700,
              color: "#111827",
              textAlign: "center",
            }}
          >
            Show Interest in{" "}
            <Box
              component="span"
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              {programName}
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,
              fontSize: "0.95rem",
              color: "#475569",
              textAlign: "center",
            }}
          >
            Choose a chapter to participate through.
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {chapterLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                py: 6,
              }}
            >
              <CircularProgress />
            </Box>
          ) : chapters.length > 0 ? (
            <>
              <Box
                sx={{
                  border: "1px solid #E5E7EB",
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                {chapters.map((chapter, index) => (
                  <Box
                    key={chapter.chapterId}
                    sx={{
                      p: 2.5,
                      display: "flex",
                      flexDirection: {
                        xs: "column",
                        sm: "row",
                      },
                      alignItems: {
                        xs: "flex-start",
                        sm: "center",
                      },
                      justifyContent: "space-between",
                      gap: 2,

                      borderBottom:
                        index !== chapters.length - 1
                          ? "1px solid #E5E7EB"
                          : "none",

                      "&:hover": {
                        background: "#FAFAFA",
                      },
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "1.05rem",
                          color: "#111827",
                        }}
                      >
                        {chapter.chapterName}
                      </Typography>
                    </Box>

                    <Button
                      variant="outlined"
                      disabled={
                        submittingChapterId === chapter.chapterId ||
                        isInterestDisabled(chapter.chapterId)
                      }
                      onClick={() => handleShowInterest(chapter)}
                      sx={{
                        minWidth: 150,
                        textTransform: "none",
                        borderRadius: 2,
                        fontWeight: 600,
                        alignSelf: {
                          xs: "stretch",
                          sm: "center",
                        },
                      }}
                    >
                      {submittingChapterId === chapter.chapterId
                        ? "Saving..."
                        : isInterestDisabled(chapter.chapterId)
                          ? "Already Shown"
                          : "Show Interest"}
                    </Button>
                  </Box>
                ))}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                py: 6,
                textAlign: "center",
              }}
            >
              <Typography color="text.secondary">No chapters found.</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProgramDetails;
